
<div class="flex flex-col h-full">
    <div 
        class="trezo-card bg-white dark:bg-[#0c1427] mb-[10px] rounded-md"
        [ngClass]="{'opacity-0 scale-75 pointer-events-none': selectedId}">
        <div class="trezo-card-header sm:flex items-center justify-between">
            <div class="trezo-card-title">
                <form class="relative sm:w-[265px]">
                    <label class="leading-none absolute ltr:left-[13px] rtl:right-[13px] text-black dark:text-white mt-px top-1/2 -translate-y-1/2">
                        <i class="material-symbols-outlined !text-[20px]">
                            search
                        </i>
                    </label>
                     <!--i18n: Search -->
                    <input 
                        type="text" 
                        [placeholder]="'i18n.app.features.pages.order.wizard.step_02.pickup-point.input_01' | translate" 
                        class="bg-gray-50 border border-gray-50 h-[36px] text-xs rounded-md w-full block text-black pt-[11px] pb-[12px] ltr:pl-[38px] rtl:pr-[38px] ltr:pr-[13px] ltr:md:pr-[16px] rtl:pl-[13px] rtl:md:pl-[16px] placeholder:text-gray-500 outline-0 dark:bg-[#15203c] dark:text-white dark:border-[#15203c] dark:placeholder:text-gray-400"
                        [formControl]="searchControl"
                        (click)="$event.stopPropagation()"
                        >
                </form>
            </div>
        </div>
    </div>

    <div 
        class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-[25px] mb-[25px] flex-1"
        [class.overflow-y-auto]="!selectedId">
        
        @for(pickupPoint of filteredPickupPoint; track pickupPoint.place?.id) {
            @if(selectedId==null){
                <pickup-point-card [(selectedId)]="selectedId" (selectedIdChange)="onSelectedIdChange($event)" [pickupPoint]="pickupPoint"></pickup-point-card>
            }
            @if(selectedId==pickupPoint?.place?.id!){
                <pickup-point-card [(selectedId)]="selectedId" (selectedIdChange)="onSelectedIdChange($event)" [pickupPoint]="pickupPoint"></pickup-point-card>
            }
            
        }
    </div>

</div>


